<template>
  <refonte-button
    class="details-back"
    variant="secondary"
    v-bind:icon_left="iconLeft"
    v-on:click="back">
    Retour
  </refonte-button>
  <div
    class="mb-8 flex w-full flex-wrap items-center justify-between lg:mb-0 lg:flex-nowrap">
    <div class="flex flex-wrap items-center lg:flex-nowrap">
      <h1 class="section__title mb-6 mr-8 mt-0">Détails de la session</h1>
      <div
        v-if="session.mentionsAccessibilite"
        class="my-4 sm:my-0">
        <display-accessibilite-icons
          v-bind:mentions_accessibilite="session.mentionsAccessibilite" />
      </div>
    </div>

    <div
      v-on:click="onOpenModalContact"
      class="flex cursor-pointer items-center whitespace-nowrap rounded bg-jinius-dark-green px-6 py-2.5 font-bold leading-none text-white shadow hover:bg-opacity-90">
      <font-awesome-icon
        icon="address-book"
        size="sm" />
      <span class="ml-3">Contacter l'organisateur</span>
    </div>
  </div>
</template>

<script>
  import displayAccessibiliteIcons from '@/components/utils/display-accessibilite-icons.vue';
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import IconChevronLeft from '@/assets/img/refonte/icons/display/icon-chevron-left.svg?component'; // <-- import SVG

  export default {
    name: 'session-header',
    components: {
      displayAccessibiliteIcons,
      FontAwesomeIcon,
      RefonteButton
    },
    props: {
      session: {
        type: Object,
        required: true
      }
    },
    emits: ['open-contact-modal'],
    data() {
      return {
        iconLeft: IconChevronLeft
      };
    },
    methods: {
      back() {
        if (!this.session) return;
        this.$router.push({
          path: '/formateur/sessions',
          query: { tab: !this.session.terminee ? 'sessions' : 'sessionsdone' }
        });
      },
      onOpenModalContact() {
        this.$emit('open-contact-modal');
      }
    }
  };
</script>
